module.exports = __webpack_public_path__ + "static/media/3.a8d7933a.jpg";